import React from "react";

import { useField } from "formik";

import {
  LivestockSalePricingTypeDisplayNameLkp,
  PricingTypeId,
} from "constants/pricingTypes";

import {
  ControlledLifeCycleInput,
  DecimalStringInputProps,
} from "./ControlledLifecycleInput";

interface UnitPriceProps {
  disabled?: boolean;
  autoFocus?: boolean;
  name: string;
  pricingTypeField: string;
  showLabel: boolean;
}

export const UnitPrice = (props: UnitPriceProps): React.JSX.Element => {
  const {
    disabled = false,
    autoFocus = false,
    name,
    pricingTypeField = "pricingTypeId",
    showLabel = true,
  } = props;

  const [{ value: pricingTypeId }] = useField(pricingTypeField);

  const pricingTypeAttributesLookup = {
    [PricingTypeId.PER_KILO]: {
      label: LivestockSalePricingTypeDisplayNameLkp[PricingTypeId.PER_KILO],
      afterSymbol: "¢",
    },
    [PricingTypeId.GROSS]: {
      label: LivestockSalePricingTypeDisplayNameLkp[PricingTypeId.GROSS],
      beforeSymbol: "$",
    },
    [PricingTypeId.PER_HEAD]: {
      label: LivestockSalePricingTypeDisplayNameLkp[PricingTypeId.PER_HEAD],
      beforeSymbol: "$",
    },
  };

  const pricingTypeAttributes = pricingTypeAttributesLookup[pricingTypeId];

  return (
    <ControlledLifeCycleInput
      {...DecimalStringInputProps}
      label={showLabel && (pricingTypeAttributes?.label || "Price")}
      name={name}
      autoFocus={autoFocus}
      disabled={disabled}
      disableAutoComplete
    />
  );
};
